import React from 'react'

export default function About() {
    return (
        <React.Fragment>
            <h1>About</h1>
            <p>  This is the react course </p>
        </React.Fragment>
    )
}
